import React from 'react';
import { Modal, Button } from 'react-bootstrap';

/**
 * Standardizes the "Are you sure you want to delete this…?" confirmation modal
 * repeated across nearly every CRUD file.
 *
 * Props:
 *   show, onHide, onConfirm
 *   title         header text (default "Confirm Deletion")
 *   bodyText      confirmation prompt
 *   confirmLabel  default "Delete"
 *   cancelLabel   default "Close"
 */
const ConfirmDeleteModal = ({
  show,
  onHide,
  onConfirm,
  title = 'Confirm Deletion',
  bodyText = 'Are you sure you want to delete this item?',
  confirmLabel = 'Delete',
  cancelLabel = 'Close',
}) => (
  <Modal show={show} onHide={onHide}>
    <Modal.Header closeButton>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>{bodyText}</Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onHide}>
        {cancelLabel}
      </Button>
      <Button variant="danger" onClick={onConfirm}>
        {confirmLabel}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default ConfirmDeleteModal;
